import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { shape, string, object } from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isnull';

const SafeGatsbyImage = ({ image, ...others }) => {
  if (isNull(image)) {
    return null;
  }

  const { alternativeText = '', localFile } = image;
  const imageToUse = getImage(localFile);

  return (!isUndefined(imageToUse) && <GatsbyImage image={imageToUse} alt={alternativeText} {...others} />) || null;
};

SafeGatsbyImage.propTypes = {
  image: shape({ alternativeText: string, localFile: object }),
};

SafeGatsbyImage.defaultProps = {
  image: { alternativeText: '', localFile: undefined },
};

export default SafeGatsbyImage;
